import { logServiceAPI } from 'src/libraries/axios';
import config from 'src/config';

export default function errorLogService(error, stacktrace, metaData) {
  const buildVersion = document.querySelector("meta[name='build-version']");
  const logService = logServiceAPI();
  const {
    storageKeys: { user: userKey }
  } = config;
  const {
    height,
    orientation: { type },
    width
  } = window.screen;

  let cacheUser = localStorage.getItem(userKey);
  cacheUser = cacheUser && JSON.parse(cacheUser);

  if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
    throw error;
  }

  try {
    logService.post('/logs', {
      appName: 'Bootstrapper Web',
      stage: process.env.NODE_ENV,
      build: buildVersion && buildVersion.content,
      url: window.location.href,
      metaData,
      user: cacheUser?.id,
      type: error.name,
      error: error.message,
      stacktrace,
      userAgent: window.navigator.userAgent,
      readyState: document.readyState,
      referrer: document.referrer,
      screen: {
        orientation: type,
        height,
        width
      },
      window: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  } catch (e) {
    console.error(e);
  }
}
